import { Box, DialogTitle, styled, Tabs as TabsMui } from '@mui/material';

export const DevToolsTitle = styled(DialogTitle)({
  borderBottom: '1px solid #E9EAEE',
  paddingBottom: '16px',
  color: 'black',
  margin: '20px 30px 0 20px',
  padding: '10px 0px 20px 10px',
  fontSize: '18px',
  cursor: 'default'
});

export const TabContainer = styled(Box)({
  color: 'black',
  display: 'flex',
  width: '100%',
  height: '100%'
});

export const Tabs = styled(TabsMui)({
  padding: '18px 0',
  '.MuiTabs-indicator': {
    display: 'none'
  },
  '.MuiTab-root': {
    fontSize: '14px',
    fontWeight: 500,
    color: 'rgb(44, 53, 66)',
    marginBottom: 8,
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    '&:hover': {
      color: 'rgb(137, 147, 164)',
      backgroundColor: 'rgb(235, 245, 255)',
      fontWeight: 500
    },
    '&.Mui-selected': {
      color: 'rgb(137, 147, 164)',
      backgroundColor: 'rgb(235, 245, 255)',
      fontWeight: 500
    }
  }
});

export const TabTitle = styled(Box)({
  color: '#000000',
  width: '100%',
  padding: '0px 0px 0px 32px',
  fontWeight: 400,
  fontSize: 16,
  textTransform: 'initial',
  textAlign: 'left',
  span: {
    fontWeight: 400,
    fontSize: 12,
    display: 'block'
  }
});

export const TabContent = styled(Box)({
  padding: '20px 20px 0 30px',
  display: 'flex',
  borderLeft: '1px solid #E9EAEE',
  flexDirection: 'column'
});

export const TabContentSection = styled(Box)({
  marginBottom: '30px'
});

export const TabContentSectionTitle = styled(Box)({
  fontSize: '14px',
  fontWeight: 500,
  textTransform: 'uppercase'
});
